<template>
  <div
    class="pt-radio-element flex flex-row-reverse lg:justify-end"
    @click="selectRadio"
  >
    <input
      :id="id"
      :name="name"
      :value="isCustomized ? customDuration : value"
      type="radio"
      class="pt-radio-input"
    />
    <label
      :for="id"
      class="pt-radio-label"
    >
      <span v-if="isCustomized">
        For <input
          v-model="customDuration"
          :min="1"
          :max="24"
          class="border-2 border-grey rounded"
          type="number"
        /> hours
      </span>
      <span v-else>
        {{ label }}
      </span>
    </label>
    <div class="pt-radio-input-check" />
  </div>
</template>

<script>
import randomGenerator from '@utils/random-id-generator';
import { PtFormInput } from '@pathao/ui-components';
export default {
  name: 'UnavailabilityModalRadio',
  components: {
    PtFormInput,
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    label: {
      type: String,
      default: 'Radio',
    },
    selected: {
      type: [String, Number, Boolean],
      default: null,
    },
    isCustomized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: randomGenerator(this.name),
      customDuration: 1,
    };
  },
  watch: {
    selected() {
      this.makeInputSelected();
    },
    customDuration() {
      this.$emit('customDurationChanged', this.customDuration);
    },
  },
  mounted() {
    this.makeInputSelected();
  },
  methods: {
    makeInputSelected() {
      const inputEl = this.$el.querySelector(`input#${this.id}`);

      if (this.value === this.selected && inputEl && !inputEl.checked) {
        inputEl.click();
      }
    },
    selectRadio() {
      this.makeInputSelected();
      this.$emit('input', this.value);
    },
  },
};
</script>
